var _templateObject = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n'], ['\n  display: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  div {\n    margin-right: ', ';\n    margin-bottom: 8px;\n\n    @media (max-width: 400px) {\n      margin-bottom: 4px !important;\n      margin-top: 4px;\n    }\n  }\n  div:first-of-type {\n    margin-left: 0px;\n  }\n  div:last-of-type {\n    margin-right: 0px;\n  }\n'], ['\n  div {\n    margin-right: ', ';\n    margin-bottom: 8px;\n\n    @media (max-width: 400px) {\n      margin-bottom: 4px !important;\n      margin-top: 4px;\n    }\n  }\n  div:first-of-type {\n    margin-left: 0px;\n  }\n  div:last-of-type {\n    margin-right: 0px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import Button from '../Button';
var Wrapper = styled.div(_templateObject, function (props) {
  return props.inline ? 'inline-block' : 'block';
}, function (props) {
  return props.inline ? '8px' : '0px';
}, function (props) {
  return props.inline ? '8px' : '0px';
});
var Container = styled.div(_templateObject2, function (props) {
  return props.size === 'small' ? '8px' : '8px';
});

var ButtonGroup = function ButtonGroup(props) {
  var size = props.size || 'medium';
  var colour = props.colour || 'primary';
  var unselectedColour = props.unselected || 'neutral';
  return React.createElement(Wrapper, props, React.createElement(Container, props, props.buttons.map(function (button, index) {
    var selectedColour = props.selected === button.value ? colour : unselectedColour;
    return React.createElement(Button, {
      inline: props.inline,
      key: index,
      onClick: function onClick() {
        return props.setSelectedButton(button.value);
      },
      colour: selectedColour,
      size: size
    }, button.label);
  })));
};

export default ButtonGroup;